import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-[#121212] text-white hover:bg-[#121212]/90",
        primary: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        error: "bg-error text-error-foreground hover:bg-error/90",
        warning: "bg-warning text-warning-foreground hover:bg-warning/90",
        info: "bg-info text-info-foreground hover:bg-info/90",
        success: "bg-success text-success-foreground hover:bg-success/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-12 rounded-md px-4 py-2",
        sm: "h-9 rounded-md px-3",
        md: "h-10 px-4 py-2",
        lg: "h-11 rounded-md px-8",
        xl: "h-14 rounded-md px-6 py-3", // New touch-friendly size
        icon: "size-10",
        "icon-sm": "size-8",
        "icon-lg": "size-11", // New touch-friendly icon size (44px)
        "icon-xl": "size-12", // Extra large touch-friendly icon size
        touch: "h-12 min-h-11 px-4 py-3", // Touch-optimized default
        "touch-sm": "h-11 min-h-10 px-3 py-2", // Touch-optimized small
        "touch-lg": "h-14 min-h-12 px-6 py-3", // Touch-optimized large
      },
    },
    compoundVariants: [
      { variant: "link", size: "sm", className: "h-auto p-0" },
      { variant: "link", size: "md", className: "h-auto p-0" },
      { variant: "link", size: "lg", className: "h-auto p-0" },
      { variant: "link", size: "xl", className: "h-auto p-0" },
      { variant: "link", size: "touch", className: "h-auto p-0" },
      { variant: "link", size: "touch-sm", className: "h-auto p-0" },
      { variant: "link", size: "touch-lg", className: "h-auto p-0" },
    ],
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
